import React from 'react';
import PropTypes from 'prop-types';
import AccountUserList from './AccountUserList';
import Actions from 'components/ui/general/Actions';
import ActiveStateButton from 'components/button/ActiveStateButton';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import AccountProductsList from './AccountProductsList';
import AccountRoleTextField from 'components/show/AccountRoleTextField';
import authHelper from 'helpers/auth';
import rolesHelper from 'helpers/roles';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import { updateAccountFailure, updateAccountSuccess } from 'store/actions/accounts/updateAccounts';

class AccountsShow extends React.Component {
    render() {
        const {
            id,
            history,
            record,
            resource,
            translate,
        } = this.props;

        const hasTransactionInformation = !!record.vat || !!record.iban || !!record.bic || !!record.registration;
        const isAdmin = authHelper.isAdmin();

        const accountInfo = `${ record.name } (${ record.id })`;

        const breadcrumbs = [
            {
                label: translate('resources.accounts.title'),
                link: '/accounts',
            },
            {
                label: accountInfo,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ accountInfo } />

                    <Actions>
                        <ActiveStateButton
                            active={ record.is_enabled }
                            failureAction={ updateAccountFailure }
                            id={ record.id }
                            resource='accounts'
                            role={ rolesHelper.getRole(record.role_id) }
                            successAction={ updateAccountSuccess }
                        />

                        <EditButton
                            icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                            primary={ false }
                            record={ record }
                            url={ `/${ resource }/${ record.id }` }
                        />
                    </Actions>
                </Header>

                <Section>
                    <Column title={ translate('resources.accounts.forms.general') }>
                        <InnerColumn>
                            <TextField
                                label='resources.accounts.fields.name'
                                value={ record.name }
                            />

                            <AccountRoleTextField
                                label='resources.accounts.fields.role'
                                value={ record.role_id }
                            />
                        </InnerColumn>
                    </Column>

                    <Column title={ translate('resources.accounts.forms.address') }>
                        <InnerColumn>
                            <TextField
                                label='resources.accounts.fields.address'
                                value={ record.address }
                            />

                            <TextField
                                label='resources.accounts.fields.zipcode'
                                value={ record.zipcode }
                            />

                            <TextField
                                label='resources.accounts.fields.city'
                                value={ record.city }
                            />

                            <TextField
                                label='resources.accounts.fields.country'
                                value={ record.country }
                            />
                        </InnerColumn>
                    </Column>
                </Section>

                <Section>
                    <Column title={ translate('resources.accounts.forms.contact') }>
                        <InnerColumn>
                            <TextField
                                label='resources.accounts.fields.email'
                                value={ record.email }
                            />

                            <TextField
                                label='resources.accounts.fields.phone'
                                value={ record.phone }
                            />
                        </InnerColumn>
                    </Column>

                    { hasTransactionInformation &&
                        <Column title={ translate('resources.accounts.forms.registrations') }>
                            <InnerColumn>
                                <TextField
                                    label='resources.accounts.fields.vat'
                                    value={ record.vat }
                                    uppercase
                                />

                                <TextField
                                    label='resources.accounts.fields.iban'
                                    value={ record.iban }
                                    uppercase
                                />

                                <TextField
                                    label='resources.accounts.fields.bic'
                                    value={ record.bic }
                                    uppercase
                                />

                                <TextField
                                    label='resources.accounts.fields.registration'
                                    value={ record.registration }
                                    uppercase
                                />
                            </InnerColumn>
                        </Column>
                    }
                </Section>

                { isAdmin &&
                    <Section>
                        <Column title='Users'>
                            <InnerColumn>
                                <AccountUserList
                                    id={ id }
                                    resource={ resource }
                                />
                            </InnerColumn>
                        </Column>
                    </Section>
                }

                <Section>
                    <AccountProductsList
                        id={ id }
                        history={ history }
                    />
                </Section>
            </div>
        );
    }
}

AccountsShow.propTypes = {
    id: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    record: PropTypes.shape({
        address: PropTypes.string,
        bic: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        email: PropTypes.string,
        iban: PropTypes.string,
        id: PropTypes.number,
        is_enabled: PropTypes.bool.isRequired,
        name: PropTypes.string,
        phone: PropTypes.string,
        role_id: PropTypes.number,
        registration: PropTypes.string,
        vat: PropTypes.string,
        zipcode: PropTypes.string,
    }).isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AccountsShow);



// WEBPACK FOOTER //
// ./src/pages/accounts/show/AccountsShow.js